// Generated by CoffeeScript 2.7.0
var ItemPicker;

export default ItemPicker = Vue.extend({
  props: {
    items: {
      type: Array
    },
    groupLength: {
      type: Number,
      default: 9
    },
    wrapperClass: {
      type: [String, Array]
    }
  },
  data: function() {
    return {
      itemGroups: this.items.groupByLength(this.groupLength)
    };
  },
  template: `<div class='item-picker-wrapper' :class='wrapperClass'>
  <div class='item-group'
       v-for='(group, index) in itemGroups'
       :key='index'>
    <div class='item-wrapper'
         v-for='item in group'
         :key='item'
         @click='pickItem(item)'>
      <slot name='item-template' :item='item'>
      </slot>
    </div>
  </div>
</div>`,
  methods: {
    pickItem: function(item) {
      return this.$emit('valueChanged', item);
    }
  }
});
